import { useEffect, useRef, useState } from 'react';
import '../css/Dashboardpage.css';
import '../css/EnquiryDetails.css';
import Popup from './Popup';
import ActiveUserResponse from '../model/response/ActiveuserResponse';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import ActiveUserRequest from '../model/request/ActiveUserRequest';
import { toast, ToastContainer } from 'react-toastify';
import PaiduserDatalist from '../model/response/PaiduserDatalist';
import ProfileListData from '../model/response/ProfileListData';
import ProfileListRequest from '../model/request/ProfileListRequest';
import PaymentListRequest from '../model/request/Paymentlistrequest';
import PaymentListResponse from '../model/response/PaymentListResponse';
import logo from '../images/logo.jpeg';
import user from '../images/user.png';
import Documentpopup from './Documentpopup';
import { Navigate, useNavigate } from 'react-router-dom';
import { Oval } from "react-loader-spinner";
import Reportcount from './Reportcount';
import Numberpopup from './Mobileverifypopup';
import DocumentUploadManualy from './Documentverifymanualy';
import ReportChart from './Reportchart';
import LookUpRequest from '../model/request/LookupRequest';

function Dashboard() {
   const calledOnce = useRef(false);
   const [showPopup, setShowPopup] = useState(false);
   const [isHide, setHide] = useState(false)
   const [activeUser, setActiveUser] = useState([]);
   const [profile, SetProfile] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [pageLoading, setPageLoading] = useState(true);
   const [showReport, setShowReport] = useState(false);
   const [numberVerify, setNumberVerify] = useState(false);
   const [selectedUser, setSelectedUser] = useState(null);
   const [selectedEditUser, setSelectedEditUser] = useState(null);
   const [documentStatus, setDocumentstatus] = useState();
   const [documentUser, setDocumentUser] = useState();
   const [documentList, setDocumentList] = useState([]);
   const [showReportChart, setShowReportChart] = useState(false);
   const [showSettings, setShowSettings] = useState(false);
   const [showColorSettings, setShowColorSettings] = useState(false);
   const [themeColorList, setThemeColorList] = useState([]);
   const [themeColors, setThemeColors] = useState({});

   const [showRolePopup, setShowRolePopup] = useState(false);
   const [selectedRoleUser, setSelectedRoleUser] = useState(null);
   const [selectedRole, setSelectedRole] = useState("User");
   const [showRole, setShowRole] = useState(false);
   const [showEnquiry, setShowEnquiry] = useState(false);
   const [enquiries, setEnquiries] = useState([]);
   const [enquiryLoading, setEnquiryLoading] = useState(false);
   const [showEnquiryModal, setShowEnquiryModal] = useState(false);
   const [enquiryModalType, setEnquiryModalType] = useState("add");
   const [selectedEnquiry, setSelectedEnquiry] = useState(null);
   const [stateList, setStateList] = useState([]);
   const [districtList, setDistrictList] = useState([]);

   const [enquiryForm, setEnquiryForm] = useState({
      id: 0,
      phone_Number: "",
      enquiry_Date: "",
      name: "",
      state: "",
      place: ""
   });

   const [deleteEnquiryId, setDeleteEnquiryId] = useState(null);
   const [showDeleteEnquiryModal, setShowDeleteEnquiryModal] = useState(false);
   const [enquirySaving, setEnquirySaving] = useState(false);


   const [showEditPopupGender, setShowEditPopupGender] = useState(false);
   const [showEditPopupPhone, setShowEditPopupPhone] = useState(false);
   const [editGender, setEditGender] = useState("");
   const [editMobile, setEditMobile] = useState("");

   const [genderFilter, setGenderFilter] = useState("All");
   const [searchText, setSearchText] = useState("");
   const [documentFilter, setDocumentFilter] = useState("All");
   const [paidFilter, setPaidFilter] = useState("All");
   const searchInitialLoad = useRef(true);


   const rawVal = localStorage.getItem('loginVal');
   let loginVal = rawVal ? JSON.parse(rawVal) : null;
   let token = loginVal ? loginVal.token : null;



   useEffect(() => {

      if (searchInitialLoad.current) {
         searchInitialLoad.current = false;
         return;
      }

      const timer = setTimeout(() => {

         activeUserAPICall(
            genderFilter,
            searchText,
            documentFilter,
            paidFilter
         );

      }, 400);

      return () => clearTimeout(timer);

   }, [searchText]);

   const navigation = useNavigate()
   function clicktoAdminlogin() {
      localStorage.clear();
      localStorage.removeItem('loginVal');
      localStorage.removeItem('token');
      navigation('/Adminlogin')
   }

   function clicktoEnquirydetails() {
      setShowEnquiry(true);
      setShowRole(false);
      setShowReport(false);
      setShowReportChart(false);
      setShowColorSettings(false);

      getEnquiries();
   }

   const stateAPICall = async () => {
      try {
         const request = new LookUpRequest();
         request.countrycode = "IN";

         const response = await axios.post(
            ApiConfig.getUrl("User/state"),
            JSON.stringify(request),
            {
               headers: {
                  "Content-Type": "application/json",
               },
            }
         );

         const dataList =
            response.data?.response?.dataList || [];

         setStateList(dataList);

         return dataList;
      } catch (error) {
         console.error("State API Error:", error);
         setStateList([]);
         return [];
      }
   };

   const districtAPICall = async (code) => {
      try {
         const request = new LookUpRequest();
         request.state_code = code;

         const response = await axios.post(
            ApiConfig.getUrl("User/district"),
            JSON.stringify(request),
            {
               headers: {
                  "Content-Type": "application/json",
               },
            }
         );

         const dataList =
            response.data?.response?.dataList || [];

         setDistrictList(dataList);

         return dataList;
      } catch (error) {
         console.error("District API Error:", error);
         setDistrictList([]);
         return [];
      }
   };

   const getEnquiries = async () => {
      try {
         setEnquiryLoading(true);

         const response = await axios.get(
            ApiConfig.getUrl("User/GetEnquiry"),
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
               },
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200 && api.status === true) {
            setEnquiries(api.response || []);
         } else {
            setEnquiries([]);
            toast.error(
               api.message || "Failed to load enquiries"
            );
         }

      } catch (error) {
         console.error("Get Enquiry Error:", error);
         setEnquiries([]);
         toast.error("Failed to load enquiry details");

      } finally {
         setEnquiryLoading(false);
      }
   };
   const openAddEnquiry = () => {

      setEnquiryModalType("add");

      setSelectedEnquiry(null);

      setEnquiryForm({
         id: 0,
         phone_Number: "",
         enquiry_Date: new Date().toISOString().split("T")[0],
         name: "",
         state: "",
         place: ""
      });

      setDistrictList([]);

      stateAPICall();

      setShowEnquiryModal(true);
   };

   const openEditEnquiry = async (item) => {
      try {
         setEnquiryModalType("edit");
         setEnquirySaving(false);

         // First load states
         const states = await stateAPICall();

         // Existing enquiry state
         const enquiryState = item.state || "";

         // Find matching state
         const selectedState = states.find(
            (state) =>
               getStateName(state).toLowerCase() ===
               String(enquiryState).toLowerCase() ||
               getStateCode(state) === String(enquiryState)
         );

         let stateCode = "";
         let stateName = enquiryState;

         if (selectedState) {
            stateCode = getStateCode(selectedState);
            stateName = getStateName(selectedState);
         }

         // IMPORTANT:
         // State code கிடைத்தவுடன் District API call
         let districts = [];

         if (stateCode) {
            districts = await districtAPICall(stateCode);
         }

         // Existing district/place
         const enquiryPlace = item.place || "";

         const selectedDistrict = districts.find(
            (district) =>
               getDistrictName(district).toLowerCase() ===
               String(enquiryPlace).toLowerCase()
         );

         const placeName = selectedDistrict
            ? getDistrictName(selectedDistrict)
            : enquiryPlace;

         // Set form
         setEnquiryForm({
            id: item.id || 0,
            phone_Number: item.phone_Number || "",
            enquiry_Date: item.enquiry_Date
               ? String(item.enquiry_Date).substring(0, 10)
               : "",
            name: item.name || "",
            state: stateName,
            place: placeName,
         });

         setShowEnquiryModal(true);

      } catch (error) {
         console.error("Edit Enquiry Error:", error);
         toast.error("Unable to load enquiry");
      }
   };

   const handleEnquiryChange = (e) => {

      const { name, value } = e.target;

      setEnquiryForm((prev) => ({
         ...prev,
         [name]: value
      }));
   };
   const saveEnquiry = async () => {

      if (!enquiryForm.name.trim()) {
         toast.error("Please enter name");
         return;
      }

      if (!enquiryForm.phone_Number.trim()) {
         toast.error("Please enter phone number");
         return;
      }

      if (!enquiryForm.enquiry_Date) {
         toast.error("Please select enquiry date");
         return;
      }

      try {

         setEnquirySaving(true);

         const payload = {
            id:
               enquiryModalType === "edit"
                  ? enquiryForm.id
                  : 0,

            phone_Number: enquiryForm.phone_Number,

            enquiry_Date:
               enquiryForm.enquiry_Date,

            name: enquiryForm.name,

            state: enquiryForm.state,

            place: enquiryForm.place
         };

         console.log(
            "ENQUIRY SAVE PAYLOAD:",
            payload
         );

         let response;

         if (enquiryModalType === "add") {

            response = await axios.post(
               ApiConfig.getUrl("User/AddEnquiry"),
               payload,
               {
                  headers: {
                     "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`
                  }
               }
            );

         } else {

            response = await axios.put(
               ApiConfig.getUrl("User/EditEnquiry"),
               payload,
               {
                  headers: {
                     "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`
                  }
               }
            );
         }

         const api = ApiResponse.fromJson(response.data);

         if (
            api.statusCode === 200 &&
            api.status === true
         ) {

            toast.success(
               enquiryModalType === "add"
                  ? "Enquiry added successfully"
                  : "Enquiry updated successfully"
            );

            setShowEnquiryModal(false);

            setSelectedEnquiry(null);

            setEnquiryForm({
               id: 0,
               phone_Number: "",
               enquiry_Date: "",
               name: "",
               state: "",
               place: ""
            });

            // Refresh enquiry table
            getEnquiries();

         } else {

            toast.error(
               api.message ||
               api.errorMessage ||
               "Failed to save enquiry"
            );
         }

      } catch (error) {

         console.error(
            "Save Enquiry Error:",
            error
         );

         toast.error(
            error.response?.data?.message ||
            error.response?.data?.errorMessage ||
            "Failed to save enquiry"
         );

      } finally {

         setEnquirySaving(false);
      }
   };

   const deleteEnquiry = async () => {

      if (!deleteEnquiryId) {
         return;
      }

      try {

         setEnquirySaving(true);

         const response = await axios.delete(
            ApiConfig.getUrl("User/DeleteEnquiry"),
            {
               params: {
                  id: deleteEnquiryId
               },
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
               }
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (
            api.statusCode === 200 &&
            api.status === true
         ) {

            toast.success(
               "Enquiry deleted successfully"
            );

            setShowDeleteEnquiryModal(false);

            setDeleteEnquiryId(null);

            getEnquiries();

         } else {

            toast.error(
               api.message ||
               api.errorMessage ||
               "Failed to delete enquiry"
            );
         }

      } catch (error) {

         console.error(
            "Delete Enquiry Error:",
            error
         );

         toast.error(
            error.response?.data?.message ||
            error.response?.data?.errorMessage ||
            "Failed to delete enquiry"
         );

      } finally {

         setEnquirySaving(false);
      }
   };
   function clicktoReportcount() {
      setIsLoading(true);

      setTimeout(() => {
         setShowReport(true);
         setIsLoading(false);
      }, 800);
   }
   function showToast(message) {
      toast.success(message, {
         position: "top-right",
         autoClose: 2000
      });
   }
   function showToastFailed(message) {
      toast.error(message, {
         position: "top-right",
         autoClose: 2000
      });
   }

   useEffect(() => {

      const loadDashboard = async () => {

         if (!loginVal) {
            showToastFailed("Session expired. Please login.");
            navigation('/Adminlogin');
            setPageLoading(false);
            return;
         }

         if (Number(loginVal.role) !== 1) {
            showToastFailed("Unauthorized access. Admin role required.");
            navigation('/Adminlogin');
            setPageLoading(false);
            return;
         }

         if (calledOnce.current) return;
         calledOnce.current = true;

         try {

            setPageLoading(true);

            await Promise.all([
               activeUserAPICall(),
               TotalPaymentListAPICall()
            ]);

         } catch (error) {

            console.error("Dashboard loading error:", error);

         } finally {

            setPageLoading(false);

         }
      };

      loadDashboard();

   }, []);
   async function activeUserAPICall(
      gender = genderFilter,
      search = searchText,
      documentStatus = documentFilter,
      paidStatus = paidFilter
   ) {
      try {

         setIsLoading(true);
         const response = await axios.post(
            ApiConfig.getUrl("User/getActiveUsers"),
            {
               gender: gender,
               search: search,
               documentStatus: documentStatus,
               paidStatus: paidStatus
            },
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
               }
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200) {

            const paiduser =
               api.response?.paid_Users?.map(item =>
                  PaiduserDatalist.fromJson(item)
               ) || [];

            const decryptedUsers = await Promise.all(
               paiduser.map(async (item) => {
                  try {
                     const decryptedMobile = await ApiConfig.decrypt(
                        item?.mobileNumber ?? ""
                     );

                     return {
                        ...item,
                        mobileNumber: decryptedMobile
                     };

                  } catch (error) {

                     console.error(
                        "Mobile decrypt error for user:",
                        item?.user_Id,
                        error
                     );

                     return {
                        ...item,
                        mobileNumber: ""
                     };
                  }
               })
            );

            setActiveUser(decryptedUsers);

         } else {
            setActiveUser([]);
         }

      } catch (error) {

         console.error("Active users error:", error);
         setActiveUser([]);

      } finally {
         setIsLoading(false);
      }
   }

   function TotalPaymentListAPICall() {
      setIsLoading(true);
      console.log("Response:", "response.data");
      axios.get(
         ApiConfig.getUrl("User/TotalPaymentList"),
         {

            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            console.log("Response:", response.data);
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);

            if (api.statusCode == 200) {
               const interestList = PaymentListResponse.fromJson(api.response);
               console.log("Response:", api.interestList);
               SetProfile(interestList);
               setIsLoading(false);


            }
         })

   }



   function updateRole() {

      setIsLoading(true);

      axios.put(
         ApiConfig.getUrl("User/updateRole"),
         {
            user_Id: selectedRoleUser.user_Id,
            role_Id: selectedRole
         },
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then((response) => {

            const api = ApiResponse.fromJson(response.data);

            if (api.statusCode === 200) {

               showToast("Role updated successfully");

               setShowRolePopup(false);

               activeUserAPICall();
            }
            else {
               showToastFailed(api.errorMessage);
            }

            setIsLoading(false);
         })
         .catch((error) => {

            setIsLoading(false);

            console.error(error);

            showToastFailed("Role update failed");
         });
   }



   const UpdateGender = async () => {

      if (!selectedEditUser?.user_Id) {
         toast.error("User not selected");
         return;
      }

      try {
         setIsLoading(true);

         const userId = selectedEditUser.user_Id;
         const gender = editGender || "";

         const response = await axios.put(
            `${ApiConfig.getUrl("User/UpdateUserBasic")}?userId=${userId}&gender=${encodeURIComponent(gender)}`,
            {},
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
               }
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200 && api.status === true) {

            setShowEditPopupGender(false);
            setSelectedEditUser(null);

            // Full page refresh
            window.location.reload();

         } else {
            showToastFailed(
               api.errorMessage ||
               api.message ||
               "Gender update failed"
            );
         }

      } catch (error) {

         console.error("UpdateGender error:", error);

         showToastFailed(
            error.response?.data?.errorMessage ||
            error.response?.data?.message ||
            "Gender update failed"
         );

      } finally {
         setIsLoading(false);
      }
   };


   const UpdateMobile = async () => {

      if (!selectedEditUser?.user_Id) {
         toast.error("User not selected");
         return;
      }

      try {
         setIsLoading(true);

         const userId = selectedEditUser.user_Id;
         const phone = editMobile || "";

         const response = await axios.put(
            `${ApiConfig.getUrl("User/UpdateUserBasic")}?userId=${userId}&phone=${encodeURIComponent(phone)}`,
            {},
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
               }
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200 && api.status === true) {

            setShowEditPopupPhone(false);
            setSelectedEditUser(null);

            // Full page refresh
            window.location.reload();

         } else {
            showToastFailed(
               api.errorMessage ||
               api.message ||
               "Mobile update failed"
            );
         }

      } catch (error) {

         console.error("UpdateMobile error:", error);

         showToastFailed(
            error.response?.data?.errorMessage ||
            error.response?.data?.message ||
            "Mobile update failed"
         );

      } finally {
         setIsLoading(false);
      }
   };


   const getDocumentList = async (userId) => {
      try {

         console.log("Selected User ID:", userId);

         setIsLoading(true);

         const response = await axios.get(
            ApiConfig.getUrl("User/getDocumentList"),
            {
               params: {
                  userId: userId
               },
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
               }
            }
         );

         console.log("Document List Response:", response.data);

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200 && api.status === true) {

            setDocumentList(api.response || []);

         } else {

            setDocumentList([]);

            showToastFailed(
               api.message ||
               api.errorMessage ||
               "Document list not found"
            );
         }

      } catch (error) {

         console.error("Get Document List Error:", error);

         setDocumentList([]);

         showToastFailed(
            error?.response?.data?.message ||
            error?.response?.data?.errorMessage ||
            "Failed to get document list"
         );

      } finally {

         setIsLoading(false);

      }
   };

   const getThemeColourList = async () => {
      try {
         setIsLoading(true);

         const response = await axios.get(
            ApiConfig.getUrl("User/ThemeColourList"),
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
               },
            }
         );

         const api = ApiResponse.fromJson(response.data);

         if (api.statusCode === 200 && api.status === true) {

            const list = api.response || [];

            setThemeColorList(list);

            const colorState = {};

            list.forEach((item) => {
               colorState[item.id] = {
                  color1: item.colour1 || item.colour || "#c7c5c5",
                  color2: item.colour2 || "#000000",
               };
            });

            setThemeColors(colorState);

         } else {
            setThemeColorList([]);
            setThemeColors({});
         }

      } catch (error) {
         console.error("Theme Colour List Error:", error);

         setThemeColorList([]);
         setThemeColors({});

      } finally {
         setIsLoading(false);
      }
   };


   const handleThemeColorChange = (
      id,
      colorNumber,
      value
   ) => {

      setThemeColors((prev) => ({
         ...prev,

         [id]: {
            ...prev[id],
            [colorNumber]: value,
         },
      }));
   };


   const saveThemeColour = async (item) => {
      try {

         const loginVal = JSON.parse(
            localStorage.getItem("loginVal")
         );

         const colour = themeColors[item.id] || {};

         const colour1 = colour.color1 || "#c7c5c5";
         const colour2 = colour.color2 || "#000000";

         const combinedColor =
            `linear-gradient(90deg, ${colour1}, ${colour2})`;

         const payload = {
            id: item.id,
            description: item.description,
            colour1: colour1,
            colour2: colour2,
            colour: combinedColor,
         };

         console.log("SAVE PAYLOAD:", payload);

         const response = await axios.post(
            ApiConfig.getUrl("User/ThemeColourSave"),
            payload,
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${loginVal?.token || token}`,
               },
            }
         );

         console.log("SAVE RESPONSE:", response.data);

         if (
            response.data.status === true ||
            response.data.statusCode === 200
         ) {

            // --------------------------------
            // 1. Update selected color state
            // --------------------------------

            setThemeColors((prev) => ({
               ...prev,

               [item.id]: {
                  color1: colour1,
                  color2: colour2,
               },
            }));


            // --------------------------------
            // 2. Update THEME LIST immediately
            // --------------------------------

            setThemeColorList((prevList) =>
               prevList.map((theme) =>
                  theme.id === item.id
                     ? {
                        ...theme,
                        colour1: colour1,
                        colour2: colour2,
                        colour: combinedColor,
                     }
                     : theme
               )
            );


            // --------------------------------
            // 3. Save current selected theme
            // --------------------------------

            localStorage.setItem(
               "themeColor",
               combinedColor
            );


            // --------------------------------
            // 4. Notify other components
            // --------------------------------

            window.dispatchEvent(
               new Event("themeColorChanged")
            );


            toast.success(
               "Theme colours saved successfully"
            );
         }

         else {

            toast.error(
               response.data.message ||
               response.data.errorMessage ||
               "Theme colour save failed"
            );
         }

      } catch (error) {

         console.error(
            "Theme Colour Save Error:",
            error
         );

         console.log(
            "ERROR RESPONSE:",
            error.response?.data
         );

         toast.error(
            error.response?.data?.message ||
            error.response?.data?.errorMessage ||
            "Unable to save theme colours"
         );
      }
   };

   const getThemeColour = async () => {
      try {
         setIsLoading(true);

         const response = await axios.get(
            ApiConfig.getUrl("User/GetThemeColour"),
            {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
               },
            }
         );

         console.log("GET THEME COLOUR RESPONSE:", response.data);

         if (
            response.data.status === true ||
            response.data.statusCode === 200
         ) {

            const list = response.data.response || [];
            setThemeColorList(list);

            const colorState = {};

            list.forEach((item) => {

               let color1 = "#c7c5c5";
               let color2 = "#000000";

               /*
                API:
                linear-gradient(90deg, #c33c3c, #f5e5e5)
               */

               if (item.colour) {

                  const match = item.colour.match(
                     /linear-gradient\(\s*90deg\s*,\s*(#[0-9a-fA-F]{6})\s*,\s*(#[0-9a-fA-F]{6})\s*\)/
                  );

                  if (match) {
                     color1 = match[1];
                     color2 = match[2];
                  }
               }

               colorState[item.id] = {
                  color1: color1,
                  color2: color2,
               };

            });

            console.log(
               "THEME COLOR STATE:",
               colorState
            );

            setThemeColors(colorState);

         } else {

            setThemeColorList([]);
            setThemeColors({});
         }

      } catch (error) {

         console.error(
            "Get Theme Colour Error:",
            error
         );

         setThemeColorList([]);
         setThemeColors({});

      } finally {

         setIsLoading(false);
      }
   };

   const openThemeColors = () => {
      setShowColorSettings(true);
      getThemeColour();
   };


   const getStateCode = (item) =>
      item.code || item.state_code || item.stateCode || "";

   const getStateName = (item) =>
      item.name || item.state_name || item.stateName || "";

   const getDistrictName = (item) =>
      item.name || item.district_name || item.districtName || "";

   // <Popup show={showPopup} onClose={() =>  setShowPopup(false)}>

   //    <p>
   //       <Documentpopup />

   //    </p>

   // </Popup>


   // const dateOfBirth = new Date('1990-01-01');
   // const formattedDate = format(dateOfBirth,'dd-MM-yyyy');

   if (pageLoading) {
      return null;
   }

   // If user is not an Admin, stop rendering the page entirely
   if (!loginVal || Number(loginVal.role) !== 1) {
      return null;
   }
   // const disableRightClick = (e) => {
   //    e.preventDefault();
   // };  onContextMenu={disableRightClick}

   return (
      <div>
         {isLoading && (
            <div className="loader-overlay" >
               <Oval
                  height={60}
                  width={60}
                  color="#ffffff"
                  secondaryColor="#cccccc"
                  strokeWidth={4}
                  visible={true}
               />
            </div>
         )}
         <div className="dashboard_fullpage " style={{ fontFamily: " font-family: Arial, Helvetica, sans-serif" }}>
            <div className={isHide ? 'left_menu hide' : 'left_menu'} style={{ backgroundColor: "var(--primary-color)", position: "sticky" }} >
               <ul className="menu_list text-light fw-bold mt-5">


                  <img src={logo} alt='logo' style={{ width: '50%' }} />
                  <li
                     className="list_item  "
                     onClick={() => {
                        setShowRole(false);
                        setShowReport(false);
                        setShowReportChart(true);
                        setShowColorSettings(false);
                        setShowEnquiry(false);
                     }}
                  >
                     <i className="bi bi-speedometer2 me-1"></i>
                     Dashboard
                  </li>
                  <li
                     className="list_item "
                     onClick={() => {
                        setShowRole(false);
                        setShowReport(false);
                        setShowReportChart(false);
                        setShowColorSettings(false);
                        setShowEnquiry(false);
                     }}
                  >
                     <i className="bi bi-people me-1"></i>
                     Users
                  </li>

                  {/* <li className="list_item">Role Master </li>
                  <li className="list_item"> User Master</li>
                 
                  <li className="list_item">Validity Extension</li>
                  <li className="list_item">Member SignUp</li>
                  <li className="list_item">Manage Profile</li>
                  <li className="list_item">Password Details </li>
                  <li className="list_item">Block/Unblock Member</li> */}
                  <li className="list_item  w-75 p-3" onClick={() => {
                     setShowRole(false);
                     setShowReportChart(false);
                     setShowColorSettings(false);
                     clicktoReportcount();
                     setShowEnquiry(false);
                  }}>   <i className="bi bi-person-exclamation me-1"></i>
                     Reported User </li>
                  {/* <li className="list_item" onClick={() => navigation('/Upgrade')}> Upgrade Plan  </li> */}
                  <li className="list_item  w-75 p-3" onClick={() => {
                     setShowRole(true);
                     setShowReportChart(false);
                     setShowReport(false);
                     setShowColorSettings(false);
                     setShowEnquiry(false);
                  }}> <i className="bi bi-person-badge me-1"></i>
                     Role </li>

                  {/* 
                  <li className="list_item"> Pending Upgrade </li>
                  <li className="list_item">Change Password </li> */}

                  <li
                     className="list_item"
                     onClick={() => setShowSettings(!showSettings)}
                  >   <i className="bi bi-gear me-1"></i>
                     Settings

                     {showSettings && (
                        <ul className="settings_submenu m-0 p-0 h-10">

                           <li
                              onClick={(e) => {
                                 e.stopPropagation();

                                 setShowColorSettings(true);
                                 setShowReport(false);
                                 setShowReportChart(false);
                                 setShowRole(false);
                                 setShowEnquiry(false);
                                 getThemeColourList();
                              }}
                           >
                              <i className="bi bi-palette me-1"></i> Color
                           </li>

                        </ul>
                     )}
                  </li>
                  <li className="list_item" onClick={clicktoEnquirydetails}><i className="bi bi-person-lines-fill me-2"></i>
                     Visiter Enquiry </li>
                  <li className="list_item  w-75 p-3" onClick={clicktoAdminlogin}>   <i className="bi bi-box-arrow-right me-1"></i>
                     Logout </li>
               </ul>
            </div>


            <Popup show={showPopup} onClose={() => setShowPopup(false)}>
               <p>
                  <Documentpopup
                     userData={documentUser}
                     documentList={documentList}
                     onClose={() => setShowPopup(false)}
                  />
               </p>
            </Popup>

            <Popup show={numberVerify} onClose={() => setNumberVerify(false)}>

               <p>
                  <Numberpopup userData={selectedUser}
                     onClose={() => setNumberVerify(false)} />
               </p>
            </Popup>

            <Popup show={documentStatus} onClose={() => setDocumentstatus(false)}>

               <p>
                  <DocumentUploadManualy userData={documentUser}
                     onClose={() => setDocumentstatus(false)} />
               </p>
            </Popup>

            <Popup

               show={showRolePopup}
               onClose={() => setShowRolePopup(false)}
            >
               <div style={{ padding: "20px" }}>

                  <h3>Assign Role</h3>

                  {selectedRoleUser && (
                     <>
                        <p>
                           Name : {selectedRoleUser.name}
                        </p>

                        <label>
                           <input
                              type="radio"
                              checked={selectedRole === "1"}
                              onChange={() => setSelectedRole("1")}
                           />
                           Admin
                        </label>

                        <br />

                        <label>
                           <input
                              type="radio"
                              checked={selectedRole === "2"}
                              onChange={() => setSelectedRole("2")}
                           />
                           User
                        </label>

                        <br />
                        <br />

                        <button
                           className="send-button"
                           onClick={updateRole}
                        >
                           Save
                        </button>
                     </>
                  )}

               </div>
            </Popup>




            <div className="right_menu">

               {/* <div className="top-bar1">
               <input className="menu_line" type="checkbox" />
               <div className='toggle' onClick={() => { setHide(!isHide) }} >
                  <span className='top_line common' ></span>
                  <span className='middle_line common'></span>
                  <span className='bottom_line common'></span>
               </div>
            </div> */}

               <div className="Dashboard">


                  <h2 style={{ marginLeft: "20px", width: "100%" }}>My Dashboard</h2>
                  <p style={{ marginLeft: "20px" }}>Dashboard / <span>My Dashboard</span></p>
                  <div className='head_box w-100'>

                     <div className="member_card" style={{ backgroundColor: "var(--primary-color)" }}> {/* <img src='D:\Projects\nav-web-app\ng_matrimony_webapp\ng_matrimony_web_app\public\photo.png' /> */}
                        <img style={{ width: "80px", height: "80px" }} src={user} />
                        <p style={{ paddingLeft: "15px", marginTop: 0 }}><b className='fs-4'>Members</b> <br />
                           Total:{profile.total_Members} <br />
                           Paid:{profile.paid}<br />
                           Unpaid:{profile.unPaid}<br />
                           Free:{profile.free}
                        </p>
                     </div>


                     <div className="member_card" style={{ backgroundColor: "var(--primary-color)" }} >
                        <img style={{ width: "80px", height: "80px" }} src={user} />
                        <p style={{ paddingLeft: "15px", marginTop: 0 }}><b className='fs-4'>Groom</b><br />

                           Total:{profile.maleCount}<br />
                           Paid:{profile.malePaidCount}<br />
                           Unpaid:{profile.maleUnPaidCount}<br />
                           Free:{profile.maleFreeCount}
                        </p>
                     </div>

                     <div className="member_card" style={{ backgroundColor: "var(--primary-color)" }}>
                        <img style={{ width: "80px", height: "80px" }} src={user} />
                        <p style={{ paddingLeft: "15px", marginTop: 0 }}><b className='fs-4'>Bride</b> <br />
                           Total:{profile.feMaleCount}<br />
                           Paid:{profile.feMalePaidCount} <br />
                           Unpaid:{profile.feMaleUnPaidCount} <br />
                           Free:{profile.feMaleFreeCount}
                        </p>
                     </div>
                  </div>
               </div>   <br />

               {

                  showEnquiry ? (

                     <div
                        className="register_design w-100"
                        style={{
                           backgroundColor: "white",
                           padding: "20px"
                        }}
                     >

                        {/* ================= HEADER ================= */}

                        <div
                           className="d-flex justify-content-between align-items-center mb-3"
                        >

                           <div>

                              <h3 className="mb-1">
                                 Enquiry Details
                              </h3>

                              <small className="text-muted">
                                 Manage customer enquiries
                              </small>

                           </div>

                           <div className="d-flex gap-2">

                              {/* ADD */}

                              <button
                                 type="button"
                                 className="btn"
                                 style={{
                                    backgroundColor:
                                       "var(--primary-color)",
                                    color: "#fff"
                                 }}
                                 onClick={openAddEnquiry}
                              >
                                 <i className="bi bi-plus-lg me-2"></i>
                                 Add Enquiry
                              </button>


                              {/* REFRESH */}

                              <button
                                 type="button"
                                 className="btn"
                                 style={{
                                    backgroundColor:
                                       "var(--primary-color)",
                                    color: "#fff"
                                 }}
                                 onClick={getEnquiries}
                              >
                                 <i className="bi bi-arrow-clockwise me-2"></i>
                                 Refresh
                              </button>

                           </div>

                        </div>


                        {/* ================= TABLE ================= */}

                        <div className="table-scroll">

                           <table className="table_size">

                              <thead>

                                 <tr>

                                    <th>S.No</th>

                                    <th>Phone Number</th>

                                    <th>Enquiry Date</th>

                                    <th>Name</th>

                                    <th>State</th>

                                    <th>Place</th>

                                    <th>Action</th>

                                 </tr>

                              </thead>


                              <tbody>

                                 {enquiryLoading ? (

                                    <tr>

                                       <td
                                          colSpan="7"
                                          style={{
                                             textAlign: "center",
                                             padding: "30px"
                                          }}
                                       >
                                          Loading...
                                       </td>

                                    </tr>

                                 ) : enquiries.length === 0 ? (

                                    <tr>

                                       <td
                                          colSpan="7"
                                          style={{
                                             textAlign: "center",
                                             padding: "30px"
                                          }}
                                       >
                                          No enquiry found
                                       </td>

                                    </tr>

                                 ) : (

                                    enquiries.map((item, index) => (

                                       <tr key={item.id}>

                                          <td>
                                             {index + 1}
                                          </td>


                                          <td>
                                             {item.phone_Number || "-"}
                                          </td>


                                          <td>

                                             {item.enquiry_Date
                                                ? new Date(
                                                   item.enquiry_Date
                                                ).toLocaleDateString(
                                                   "en-IN"
                                                )
                                                : "-"}

                                          </td>


                                          <td>
                                             {item.name || "-"}
                                          </td>


                                          <td>
                                             {item.state || "-"}
                                          </td>


                                          <td>
                                             {item.place || "-"}
                                          </td>


                                          {/* ACTION */}

                                          <td>

                                             <div
                                                className="d-flex gap-2"
                                                style={{
                                                   alignItems:
                                                      "center"
                                                }}
                                             >

                                                {/* EDIT */}

                                                <button
                                                   type="button"
                                                   className="Edit-btn"
                                                   style={{
                                                      backgroundColor:
                                                         "var(--primary-color)",
                                                      color: "#fff"
                                                   }}
                                                   onClick={() =>
                                                      openEditEnquiry(item)
                                                   }
                                                >
                                                   <i className="bi bi-pencil-square"></i>
                                                   {" "}Edit
                                                </button>


                                                {/* DELETE */}

                                                <button
                                                   type="button"
                                                   className="Edit-btn w-100"
                                                   style={{
                                                      backgroundColor:
                                                         "#dc3545",
                                                      color: "#fff"
                                                   }}
                                                   onClick={() => {

                                                      setDeleteEnquiryId(
                                                         item.id
                                                      );

                                                      setShowDeleteEnquiryModal(
                                                         true
                                                      );

                                                   }}
                                                >
                                                   <i className="bi bi-trash"></i>
                                                   {" "}Delete
                                                </button>

                                             </div>

                                          </td>

                                       </tr>

                                    ))

                                 )}

                              </tbody>

                           </table>

                        </div>

                     </div>

                  ) :
                     showColorSettings ? (

                        <div
                           className="register_design w-100"
                           style={{ backgroundColor: "white" }}
                        >

                           <h3>Theme Colors</h3>

                           <div className="theme-color-list">

                              {themeColorList.length === 0 ? (

                                 <p>No theme colours found.</p>

                              ) : (

                                 themeColorList.map((item) => {

                                    const colors = themeColors[item.id] || {};

                                    const color1 = colors.color1 || "#c7c5c5";
                                    const color2 = colors.color2 || "#000000";

                                    const gradient =
                                       `linear-gradient(90deg, ${color1}, ${color2})`;

                                    return (


                                       <div
                                          className="theme-color-item"
                                          key={item.id}
                                       >

                                          {/* ===================== */}
                                          {/* DESCRIPTION */}
                                          {/* ===================== */}

                                          <div className="theme-description">
                                             {item.description}
                                          </div>


                                          {/* ===================== */}
                                          {/* COLOUR */}
                                          {/* ===================== */}

                                          <div className="theme-color-box">

                                             <label>
                                                Colour
                                             </label>

                                             {/* Gradient box */}
                                             <div
                                                className="gradient-color-selector"
                                                style={{
                                                   background: item.colour,
                                                }}
                                             >

                                                {/* Color 1 */}
                                                <input
                                                   type="color"
                                                   value={color1}
                                                   onChange={(e) =>
                                                      handleThemeColorChange(
                                                         item.id,
                                                         "color1",
                                                         e.target.value
                                                      )
                                                   }
                                                   title="Select first colour"
                                                />


                                                {/* Color 2 */}
                                                <input
                                                   type="color"
                                                   value={color2}
                                                   onChange={(e) =>
                                                      handleThemeColorChange(
                                                         item.id,
                                                         "color2",
                                                         e.target.value
                                                      )
                                                   }
                                                   title="Select second colour"
                                                />

                                             </div>


                                             {/* Selected gradient */}
                                             <div
                                                className="selected-gradient"
                                                style={{
                                                   background: gradient,
                                                }}
                                             />

                                          </div>


                                          {/* ===================== */}
                                          {/* COLOR VALUES */}
                                          {/* ===================== */}

                                          <div className="gradient-color-values">

                                             <span>
                                                {color1}
                                             </span>

                                             <span>
                                                {color2}
                                             </span>

                                          </div>


                                          {/* ===================== */}
                                          {/* SAVE */}
                                          {/* ===================== */}

                                          <button
                                             type="button"
                                             className="btn"
                                             style={{
                                                backgroundColor:
                                                   "var(--primary-color)",
                                                color: "#fff",
                                                marginTop: "10px",
                                             }}
                                             onClick={() =>
                                                saveThemeColour(item)
                                             }
                                          >
                                             Save
                                          </button>


                                       </div>

                                    );

                                 })

                              )}

                           </div>

                        </div>

                     ) :

                        showReportChart ? (

                           <ReportChart />

                        ) :
                           showReport ? (
                              <Reportcount onClose={() => setShowReport(false)} />
                           ) : showRole ? (
                              <div className="register_design w-100" style={{ backgroundColor: "white" }}>
                                 <h3>User Role Management</h3>
                                 <div className="table-scroll">
                                    <table className="table_size">
                                       <thead>
                                          <tr>
                                             <th>Name</th>
                                             <th>User Id</th>
                                             <th>Current Role</th>
                                             <th>Action</th>
                                          </tr>

                                       </thead>

                                       <tbody>
                                          {activeUser.map((item) => (
                                             <tr key={item.user_Id}>
                                                <td>{item.name}</td>
                                                <td>IMIT{item.user_number}</td>
                                                <td>{Number(item.role) === 1 ? "Admin" : "User"}</td>

                                                <td>
                                                   <button className='send-button'
                                                      onClick={() => {
                                                         setSelectedRoleUser(item);
                                                         setSelectedRole(item.role);
                                                         setShowRolePopup(true);
                                                      }}
                                                   >
                                                      Assign Role
                                                   </button>
                                                </td>
                                             </tr>
                                          ))}
                                       </tbody>
                                    </table>
                                 </div>
                              </div>

                           ) : (




                              <div className="register_design" style={{ backgroundColor: "white" }}>
                                 <div className="member-filter-container">

                                    {/* Title */}
                                    <label className="filter-title">
                                       All Registered Member
                                    </label>

                                    {/* Gender */}
                                    <select style={{ width: "200px" }} className='p-1 m-2'
                                       value={genderFilter}
                                       onChange={(e) => {
                                          const value = e.target.value;
                                          setGenderFilter(value);

                                          activeUserAPICall(
                                             value,
                                             searchText,
                                             documentFilter,
                                             paidFilter
                                          );
                                       }}
                                    >
                                       <option value="All">All Genders </option>
                                       {/* <option value="All"> All</option> */}
                                       <option value="Female">Female</option>
                                       <option value="Male">Male</option>
                                    </select>


                                    {/* Search */}
                                    <input
                                       style={{ width: "200px" }}
                                       className="m-2"
                                       type="text"
                                       placeholder="Search... IMIT000"
                                       value={searchText}
                                       onChange={(e) => {
                                          setSearchText(e.target.value);
                                       }}
                                    />


                                    {/* Document Status */}
                                    <select style={{ width: "200px" }} className='p-1 m-2'
                                       value={documentFilter}

                                       onChange={(e) => {
                                          const value = e.target.value;
                                          setDocumentFilter(value);

                                          activeUserAPICall(
                                             genderFilter,
                                             searchText,
                                             value,
                                             paidFilter
                                          );
                                       }}
                                    >
                                       <option value="All">All Documents Status</option>
                                       {/* <option value="All"> All</option> */}
                                       <option value="0">Verified</option>
                                       <option value="1">Inprogress</option>
                                       <option value="2">Rejected</option>
                                       <option value="3">Not Verified</option>
                                    </select>


                                    {/* Paid Status */}
                                    <select style={{ width: "200px" }} className='p-1 m-2'
                                       value={paidFilter}
                                       onChange={(e) => {
                                          const value = e.target.value;
                                          setPaidFilter(value);

                                          activeUserAPICall(
                                             genderFilter,
                                             searchText,
                                             documentFilter,
                                             value
                                          );
                                       }}
                                    >
                                       <option value="All">All Paid Status</option>
                                       {/* <option value="All">All</option> */}
                                       <option value="Paid">Paid</option>
                                       <option value="Unpaid">Unpaid</option>
                                    </select>

                                 </div>
                                 <div className="table-scroll">
                                    <table className='table_size'>
                                       <thead>
                                          <tr>
                                             <th>Photo</th>
                                             <th>Name (ID)</th>
                                             <th>Gender</th>
                                             <th>Joining Date</th>
                                             <th>Date of Birth</th>
                                             <th>Age</th>
                                             <th>Contact</th>
                                             <th>Mobile Verified</th>
                                             <th>Email Verified</th>
                                             <th>Documentation Verified</th>
                                             <th>Paid</th>

                                          </tr>
                                       </thead>
                                       <tbody>
                                          {activeUser.map((item) => (

                                             <tr key={item.user_Id}>

                                                {/* Photo */}
                                                <td>
                                                   <img
                                                      src={item.profileImage}
                                                      style={{
                                                         width: "200px",
                                                         height: "200px",
                                                         objectFit: "cover",
                                                         objectPosition: "center"
                                                      }}
                                                   />
                                                </td>

                                                {/* Name */}
                                                <td>
                                                   {item.name}
                                                   <br />
                                                   IMIT{item.user_number}
                                                </td>

                                                {/* Gender */}
                                                <td>
                                                   {item.gender}

                                                   <button
                                                      className="Edit-btn"
                                                      style={{ backgroundColor: "var(--primary-color" }}
                                                      onClick={() => {

                                                         setSelectedEditUser(item);

                                                         setEditGender(
                                                            item?.gender ?? ""
                                                         );

                                                         setShowEditPopupGender(true);
                                                      }}
                                                   >
                                                      Edit
                                                   </button>
                                                </td>

                                                {/* Joining Date */}
                                                <td>
                                                   {new Date(item.joining_Date).toLocaleDateString(
                                                      "en-IN",
                                                      {
                                                         day: "2-digit",
                                                         month: "2-digit",
                                                         year: "numeric"
                                                      }
                                                   )}
                                                </td>

                                                {/* Date of Birth */}
                                                <td>
                                                   {new Date(item.date_of_birth).toLocaleDateString(
                                                      "en-IN",
                                                      {
                                                         day: "2-digit",
                                                         month: "2-digit",
                                                         year: "numeric"
                                                      }
                                                   )}
                                                </td>

                                                {/* Age */}
                                                <td>
                                                   {item.age}
                                                </td>

                                                {/* Mobile Number */}
                                                <td>
                                                   {item.mobileNumber}

                                                   <button
                                                      style={{ backgroundColor: "var(--primary-color" }}
                                                      className="Edit-btn"
                                                      onClick={() => {

                                                         setSelectedEditUser(item);

                                                         // mobile already decrypted in activeUserAPICall
                                                         setEditMobile(
                                                            item?.mobileNumber ?? ""
                                                         );

                                                         setShowEditPopupPhone(true);
                                                      }}
                                                   >
                                                      Edit
                                                   </button>
                                                </td>

                                                {/* Mobile Verified */}
                                                <td>
                                                   {
                                                      item.mobileNumber_Status === true ? (
                                                         <span
                                                            style={{
                                                               color: "green",
                                                               textDecoration: "none"
                                                            }}
                                                         >
                                                            Verified
                                                         </span>
                                                      ) : (
                                                         <span
                                                            style={{
                                                               color: "red",
                                                               cursor: "pointer",
                                                               textDecoration: "none"
                                                            }}
                                                            onClick={() => {
                                                               setSelectedUser(item);
                                                               setNumberVerify(true);
                                                            }}
                                                         >
                                                            Not Verified
                                                         </span>
                                                      )
                                                   }
                                                </td>

                                                {/* Email Verified */}
                                                <td>
                                                   <span
                                                      style={{
                                                         cursor: "none",
                                                         textDecoration: "none",
                                                         color:
                                                            item.email_Status === true
                                                               ? "green"
                                                               : "red"
                                                      }}
                                                   >
                                                      {
                                                         item.email_Status === true
                                                            ? "Verified"
                                                            : "Not Verified"
                                                      }
                                                   </span>
                                                </td>

                                                {/* Documentation */}
                                                <td
                                                   style={{
                                                      cursor:
                                                         item.documentStatus === 1
                                                            ? "pointer"
                                                            : item.documentStatus === 3
                                                               ? "pointer"
                                                               : "default"
                                                   }}
                                                   onClick={async () => {

                                                      if (item.documentStatus === 1) {

                                                         console.log("Clicked User:", item);

                                                         // Selected user save
                                                         setDocumentUser(item);

                                                         // Get document list API
                                                         await getDocumentList(item.user_Id);

                                                         // Open document popup
                                                         setShowPopup(true);
                                                      }

                                                      if (item.documentStatus === 3) {

                                                         setDocumentUser(item);

                                                         setDocumentstatus(true);
                                                      }

                                                   }}
                                                >
                                                   <span
                                                      style={{
                                                         cursor: "none",
                                                         color:
                                                            item.documentStatus === 0
                                                               ? "green"
                                                               : item.documentStatus === 1
                                                                  ? "blue"
                                                                  : item.documentStatus === 2
                                                                     ? "red"
                                                                     : "red",
                                                         textDecoration: "none"
                                                      }}
                                                   >
                                                      {
                                                         item.documentStatus === 0
                                                            ? "Verified"
                                                            : item.documentStatus === 1
                                                               ? "Inprogress"
                                                               : item.documentStatus === 2
                                                                  ? "Rejected"
                                                                  : item.documentStatus === 3
                                                                     ? "Not Verified"
                                                                     : "Null"
                                                      }
                                                   </span>
                                                </td>

                                                {/* Paid */}
                                                <td>
                                                   {item.is_Paid === true
                                                      ? "Paid"
                                                      : "Unpaid"}
                                                </td>

                                             </tr>

                                          ))}
                                       </tbody>

                                    </table>
                                 </div>
                              </div>
                           )
               }
            </div>

            {/* =====================================================
    ADD / EDIT ENQUIRY MODAL
===================================================== */}

            {showEnquiryModal && (

               <div className="popup-overlay">

                  <div
                     className="edit-popup"
                     style={{
                        width: "500px",
                        maxWidth: "95%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "25px"
                     }}
                  >

                     <div
                        className="d-flex justify-content-between align-items-center mb-3"
                     >

                        <h3 style={{ margin: 0 }}>

                           {enquiryModalType === "add"
                              ? "Add Enquiry"
                              : "Edit Enquiry"}

                        </h3>

                        <button
                           type="button"
                           onClick={() =>
                              setShowEnquiryModal(false)
                           }
                           style={{
                              border: "none",
                              background: "transparent",
                              fontSize: "24px"
                           }}
                        >
                           ×
                        </button>

                     </div>


                     {/* NAME */}

                     <div className="mb-3">

                        <label className="form-label">
                           Name
                        </label>

                        <input
                           type="text"
                           name="name"
                           className="form-control"
                           placeholder="Enter name"
                           value={enquiryForm.name}
                           onChange={handleEnquiryChange}
                        />

                     </div>


                     {/* PHONE */}

                     <div className="mb-3">

                        <label className="form-label">
                           Phone Number
                        </label>

                        <input
                           type="text"
                           name="phone_Number"
                           className="form-control"
                           placeholder="Enter phone number"
                           value={enquiryForm.phone_Number}
                           onChange={handleEnquiryChange}
                           maxLength={10}
                        />

                     </div>


                     {/* DATE */}

                     <div className="mb-3">

                        <label className="form-label">
                           Enquiry Date
                        </label>

                        <input
                           type="date"
                           name="enquiry_Date"
                           className="form-control"
                           value={enquiryForm.enquiry_Date}
                           onChange={handleEnquiryChange}
                        />

                     </div>


                     {/* STATE */}

                     <div className="mb-3">
                        <label className="form-label">State</label>

                        <select
                           name="state"
                           className="form-control"
                           value={
                              stateList.find(
                                 (item) =>
                                    getStateName(item) === enquiryForm.state
                              )
                                 ? getStateCode(
                                    stateList.find(
                                       (item) =>
                                          getStateName(item) === enquiryForm.state
                                    )
                                 )
                                 : ""
                           }
                           onChange={async (e) => {
                              const selectedCode = e.target.value;

                              const selectedState = stateList.find(
                                 (item) =>
                                    String(getStateCode(item)) ===
                                    String(selectedCode)
                              );

                              const stateName = selectedState
                                 ? getStateName(selectedState)
                                 : "";

                              setEnquiryForm((prev) => ({
                                 ...prev,
                                 state: stateName,
                                 place: "",
                              }));

                              if (selectedCode) {
                                 await districtAPICall(selectedCode);
                              } else {
                                 setDistrictList([]);
                              }
                           }}
                        >
                           <option value="">Select State</option>

                           {stateList.map((item, index) => (
                              <option
                                 key={index}
                                 value={getStateCode(item)}
                              >
                                 {getStateName(item)}
                              </option>
                           ))}
                        </select>
                     </div>


                     <div className="mb-3">
                        <label className="form-label">
                           Place / District
                        </label>

                        <select
                           name="place"
                           className="form-control"
                           value={enquiryForm.place}
                           onChange={handleEnquiryChange}
                           disabled={!enquiryForm.state}
                        >
                           <option value="">
                              Select Place / District
                           </option>

                           {districtList.map((item, index) => (
                              <option
                                 key={index}
                                 value={getDistrictName(item)}
                              >
                                 {getDistrictName(item)}
                              </option>
                           ))}
                        </select>
                     </div>


                     {/* BUTTONS */}

                     <div
                        className="d-flex justify-content-end gap-2 mt-4"
                     >

                        <button
                           type="button"
                           className="btn"
                           style={{
                              backgroundColor: "grey",
                              color: "#fff"
                           }}
                           onClick={() =>
                              setShowEnquiryModal(false)
                           }
                           disabled={enquirySaving}
                        >
                           Cancel
                        </button>


                        <button
                           type="button"
                           className="btn"
                           style={{
                              backgroundColor:
                                 "var(--primary-color)",
                              color: "#fff",
                              fontWeight: "bold"
                           }}
                           onClick={saveEnquiry}
                           disabled={enquirySaving}
                        >

                           {enquirySaving
                              ? "Saving..."
                              : enquiryModalType === "add"
                                 ? "Save"
                                 : "Update"}

                        </button>

                     </div>

                  </div>

               </div>

            )}

            {/* =====================================================
    DELETE ENQUIRY MODAL
===================================================== */}

            {showDeleteEnquiryModal && (

               <div className="popup-overlay">

                  <div
                     className="edit-popup"
                     style={{
                        width: "400px",
                        maxWidth: "95%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "25px",
                        textAlign: "center"
                     }}
                  >

                     <div
                        style={{
                           fontSize: "45px",
                           color: "#dc3545",
                           marginBottom: "10px"
                        }}
                     >
                        <i className="bi bi-exclamation-triangle"></i>
                     </div>


                     <h3>
                        Delete Enquiry?
                     </h3>


                     <p
                        style={{
                           color: "#666",
                           marginTop: "10px"
                        }}
                     >
                        Are you sure you want to delete
                        this enquiry?
                     </p>


                     <div
                        className="d-flex justify-content-center gap-2 mt-4"
                     >

                        <button
                           type="button"
                           className="btn"
                           style={{
                              backgroundColor: "grey",
                              color: "#fff"
                           }}
                           onClick={() => {

                              setShowDeleteEnquiryModal(false);

                              setDeleteEnquiryId(null);

                           }}
                           disabled={enquirySaving}
                        >
                           Cancel
                        </button>


                        <button
                           type="button"
                           className="btn"
                           style={{
                              backgroundColor: "#dc3545",
                              color: "#fff",
                              fontWeight: "bold"
                           }}
                           onClick={deleteEnquiry}
                           disabled={enquirySaving}
                        >

                           {enquirySaving
                              ? "Deleting..."
                              : "Delete"}

                        </button>

                     </div>

                  </div>

               </div>

            )}
            {showEditPopupGender && (
               <div className="popup-overlay">

                  <div className="edit-popup">

                     <h3>Edit Gender</h3>

                     <label>Gender</label>

                     <select
                        value={editGender}
                        onChange={(e) =>
                           setEditGender(e.target.value)
                        }
                     >
                        <option value="">
                           Select Gender
                        </option>

                        <option value="Male">
                           Male
                        </option>

                        <option value="Female">
                           Female
                        </option>
                     </select>

                     <div className="popup-buttons">

                        <button style={{ backgroundColor: "grey", color: "var(--white)" }}
                           onClick={() =>
                              setShowEditPopupGender(false)
                           }
                        >
                           Cancel
                        </button>

                        <button style={{ background: "var(--primary-color)", color: "var(--white)", fontWeight: "bold" }}
                           onClick={UpdateGender}
                        >
                           Update
                        </button>

                     </div>

                  </div>

               </div>
            )}


            {showEditPopupPhone && (
               <div className="popup-overlay">

                  <div className="edit-popup">

                     <h3>Edit Mobile Number</h3>

                     <label>Mobile Number</label>

                     <input
                        type="text"
                        value={editMobile}
                        onChange={(e) =>
                           setEditMobile(e.target.value)
                        }
                        maxLength={10}
                     />

                     <div className="popup-buttons">

                        <button style={{ backgroundColor: "grey", color: "var(--white)" }}
                           onClick={() =>
                              setShowEditPopupPhone(false)
                           }
                        >
                           Cancel
                        </button>

                        <button style={{ background: "var(--primary-color)", color: "var(--white)", fontWeight: "bold" }}
                           onClick={UpdateMobile}
                        >
                           Update
                        </button>

                     </div>

                  </div>

               </div>
            )}


         </div>
         <footer className='bg-dark text-white text-center w-100 position-sticky'>
            <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
         </footer>
      </div>
   );
}
export default Dashboard;